import { PartnerType } from "@/app/utils/partners.enum";
import { httpClient } from "../http/httpClient";

export interface GetPublicTransactionResponse {
  status: string;
  url: string;
  _id: string;
  customerId?: string
}

export interface GetPublicTransactionParams {
  customerCpf?: string;
  sellerId?: string;
  id?: string;
  type?: PartnerType;
}

export async function getPublicTransactionPan(
  params: GetPublicTransactionParams,
) {
  const { data } = await httpClient
    .get<GetPublicTransactionResponse>(`/self-hire/status`, { params })
    .catch((err) => {
      throw err?.response?.data || err;
    });

  return data;
}
